import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getKansasCityStructuredData() {
  const url = "https://restorehair.com/locations/missouri/kansas-city/";
  const description =
    "Find out about your hair transplant options in Kansas City with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("kansas-city", url, description),
    locationPageCrumbs(url, "Kansas City"),
  ];
}
